var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateTimePickerLocal',{ref:"datepicker",staticClass:"w-full",attrs:{"value":this.item.response,"enable-date":_vm.item.params.date,"enable-time":_vm.item.params.time},on:{"change":_vm.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }